import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { order } from '@cashew/types';
import { useHistory } from 'react-router-dom';
import Pagination from '@cashew/pagination';
import classnames from 'classnames';
import OrdersFilter from './OrdersFilter';

import {
  Box,
  List,
  ListItem,
  PageWithNavigation,
  Title,
  Button,
} from '../../components';
import { RootState } from '../../reducers';
import { UserState } from '../../reducers/user';
import './index.css';

const { api } = require('@cashew/utils');

const ns = 'disputes';

/**
 * Orders Page RefundPage
 */
export default () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [list, setList] = useState<Array<order.OrderType>>([]);
  const [loadingOrders, setLoadingOrders] = useState(false);

  const { selectedStore }: UserState = useSelector(
    (state: RootState) => state.user
  );
  const [records, setRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [isData, setIsData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [isOffline, setIsOffline] = useState(true);

  useEffect(() => {
    setLoadingOrders(true);
    api
      .get({
        endpoint: 'orders',
        params: {
          storeId: selectedStore > 0 ? selectedStore : null,
          status: `${order.OrderStatusEnum.AUTHORISED}, ${order.OrderStatusEnum.REJECTED}`,
        },
      })
      .then((resp: any) => {
        setIsOffline(!!isOffline);
        setLoadingOrders(false);
        setList(
          resp.data.map((item: order.OrderType | any) => {
            const newItem: any = item;
            newItem.status = item.orderStatus;
            newItem.date = item.purchaseDate;
            newItem.goTo =
              item.productType === 'SUBSCRIPTION' ? 'subscriptions' : 'orders';
            return newItem;
          })
        );
      })
      .catch(() =>
        dispatch({
          type: 'OPEN_TOASTER',
          payload: {
            toasterTitle: t('disputes.error.title.fetchList'),
            toasterMessage: t('disputes.error.message.fetchList'),
            toasterType: 'error',
            toasterVisible: true,
            toasterDismiss: null,
          },
        })
      );
  }, [selectedStore]);

  return (
    <div className={ns}>
      <Helmet>
        <title>{t('disputes.sectionTitle')}</title>
      </Helmet>
      <PageWithNavigation>
        <Title>
          {t('disputes.title')}
          <span>
            <Button
              extraClass="blue show-filter-btn"
              onClick={() => setShowFilter(!showFilter)}
              loading={loading}
            >
              <div className="btn-with-icon">
                <img src="/fillter.svg" alt="filter" />
                Filters
              </div>
            </Button>
          </span>
        </Title>
        <div className={classnames({ 'hide-filter': !showFilter })}>
          <OrdersFilter
            setLoading={setLoading}
            useSelector={useSelector}
            setRecords={setRecords}
            setList={setList}
            pageSize={pageSize}
            pageNumber={pageNumber}
            history={history}
            dispatch={dispatch}
            isListEmpty={!isData}
            setIsData={setIsData}
            isData={isData}
            setPageNumber={setPageNumber}
            records={records}
          />
        </div>

        <Box withHeader>
          <div>
            <div className={`${ns}__headers`}>
              <p>Order ID</p>
              <p>Order date</p>
              {isOffline && <p>{t('orders.table.merchantOrderCode')}</p>}
              <p>{t('orders.table.storeName')}</p>
              <p>{t('orders.table.status')}</p>
              <p>{t('orders.table.totalAmount')}</p>
            </div>
            <List
              data={list}
              component={ListItem}
              context="disputes"
              isLoading={loadingOrders}
              t={t}
              isOffline={isOffline}
            />
            <Pagination
              records={records}
              pageSize={pageSize}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              changePageSize={setPageSize}
            />
          </div>
        </Box>
      </PageWithNavigation>
    </div>
  );
};
